__webpack_require__.p = "/table-header-icon-improvements/referrals-hub/";